var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import { DNDHTMLBackend } from "../../App/DNDHTML5Backend";
import ID from "../../../shared/uniqueID";
import { Translate } from "../../I18N";
import DragAndDropItem from "./DragAndDropItem";

export class DragAndDropContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { id: props.id || ID() };
    this.container = { id: this.state.id };
    this.moveItem = this.moveItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.renderItem = this.renderItem.bind(this);
  }

  moveItem(_dragIndex, hoverIndex, item) {
    const dragIndex = _dragIndex;
    const items = this.props.items.concat();
    if (!items.find((_item) => _item.id === item.id)) {
      return;
    }
    items.splice(dragIndex, 1);
    items.splice(hoverIndex, 0, item.originalItem || item);
    this.props.onChange(items);
  }

  removeItem(id) {
    let items = this.props.items.concat();
    items = items.filter((item) => item.id !== id);
    this.props.onChange(items);
  }

  renderItem(item, index) {
    if (this.props.renderItem) {
      return this.props.renderItem(item, index);
    }

    return item.content;
  }

  render() {
    const { connectDropTarget, items, iconHandle } = this.props;
    return /*#__PURE__*/(
      _jsx("div", {}, void 0,
      connectDropTarget( /*#__PURE__*/
      _jsx("ul", { className: "list-group" }, void 0,
      items.map((item, index) => /*#__PURE__*/
      _jsx(DragAndDropItem, {
        moveItem: this.moveItem,
        removeItem: this.removeItem,
        index: index,
        iconHandle: iconHandle || !!item.items,

        name: item.name,
        container: this.container,
        items: item.items,
        id: item.id,
        originalItem: item }, item.id,

      this.renderItem)), /*#__PURE__*/


      _jsx("div", { className: "no-properties" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "no-properties-wrap" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Drag items here")))))));






  }
}

DragAndDropContainer.defaultProps = {
  iconHandle: false
};











export const containerTarget = {
  drop(props, monitor, component) {
    const item = monitor.getItem();
    if (item.id === component.state.id) {
      return;
    }
    if (!monitor.getDropResult() || !monitor.getDropResult().id) {
      const items = props.items.concat();
      if (!items.find((_item) => _item.id === item.id)) {
        items.push(item.originalItem || item);
        props.onChange(items);
      }
      return { id: component.state.id };
    }
  }
};

const dragAndDropContainer = DropTarget('DRAG_AND_DROP_ITEM', containerTarget, (connect) => ({
  connectDropTarget: connect.dropTarget()
}))(DragAndDropContainer);

export default DNDHTMLBackend(dragAndDropContainer);